import { STATUS, useVerifyAction } from '@/providers/VerifyActionProvider';
import { Box, Flex, SimpleGrid } from '@mantine/core';
import { KycStepperItem } from './KycStepperItem';
import { KycStepperStatus } from './KycStepperStatus';
const steps = [{
  title: 'REGISTRATION',
  itemStatus: STATUS.REGISTRATION,
  success: STATUS.REGISTRATION
}, {
  title: 'VERIFY EMAIL',
  itemStatus: STATUS.VERIFY_EMAIL,
  success: STATUS.VERIFY_EMAIL
}, {
  title: 'COMPLETE PROFILE',
  itemStatus: STATUS.COMPLETE_PROFILE,
  success: STATUS.COMPLETE_PROFILE
}, {
  title: 'ID VERIFICATION',
  itemStatus: STATUS.ID_VERIFICATION,
  success: STATUS.ID_VERIFICATION
}];
export const KycStepper: React.FC = () => {
  const {
    successes
  } = useVerifyAction();
  return <Flex direction={{
    base: 'column-reverse',
    lg: 'column'
  }} w="100%" align="center" justify="center" pos="absolute" bottom={0} left={0} right={0} style={{
    zIndex: 300
  }}>
      {!successes.has(STATUS.ID_VERIFICATION) && <Box w={{
      base: '100%',
      lg: 1006
    }} bg={{
      base: 'var(--bg-300)',
      lg: 'transparent'
    }} p={15}>
          <KycStepperStatus hidden="sm" />

          <SimpleGrid cols={4} spacing={2}>
            {steps.map(item => <KycStepperItem key={item.title} {...item} />)}
          </SimpleGrid>
        </Box>}

      <KycStepperStatus visible="sm" />
    </Flex>;
};